import AdList from './AdList';
export default AdList;
